import React from 'react'
import { components } from 'cng-web-lib'

import TmpComponentApiUrls from 'src/apiUrls/TmpComponentApiUrls'
import FormProperties from './FormProperties'
import pathMap from 'src/paths/PathMap_TmpAdmin'

const {
  form: {
    CngAddForm
  }
} = components

function AddPage({ history, showNotification }) {
  return (

    <CngAddForm
      fieldLevel='toBeChangedByDeveloperIfWantFieldLevelRestriction'
      shouldDisableEnterToSubmit
      showNotification={showNotification}
      history={history}
      bodySection={
        < FormProperties.Fields
          disabled={false}
          showNotification={showNotification}
          mode={"add"}
        />
      }
      buttonText="Save"
      formikProps={FormProperties.formikProps}
      toClientDataFormat={FormProperties.toClientDataFormat}
      toServerDataFormat={FormProperties.toServerDataFormat}

      create={{
        url: TmpComponentApiUrls.CREATE,
        successRedirect: pathMap.COMPONENT_LIST_VIEW
      }}
    />
  )

}


export default AddPage
